"use client"

import {useAppStore} from "@/store/AppStore";
import {getUserFromStorage, removeUserInStorage, setUserInStorage} from "@/utils/api/Login";
import {useEffect} from "react";
import {refreshRequest} from "@/utils/api/Refresh";
import {User} from "@/types/User";
import {useRouter} from "@/i18n/routing";

export default function useCheckAuth() {
  const router = useRouter();
  const user = useAppStore((state) => state.user);
  const setLoggedInChecking = useAppStore((state) => state.setLoggedInChecking);
  const refreshNow = useAppStore((state) => {
    return state.refreshToken
  })
  const setUser = useAppStore((state) => state.setUser);
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    if (user) {
      setLoggedInChecking(false)
      return
    }
    const userFromStorage = getUserFromStorage()
    if (userFromStorage) {
      try {
        setUser(userFromStorage);
        setLoggedInChecking(false)
      } catch (error) {
        console.error('Failed to parse user from localStorage', error);
      }
    }
  }, [setLoggedInChecking, setUser, user]);

  useEffect(() => {
    if (!refreshNow) return
    if (!user?.refresh_token) {
      setUser(undefined)
      removeUserInStorage()
      router.push('/home')
    }
    const refreshTkn = async () => {
      const refresh = await refreshRequest(String(user?.refresh_token))
      if (refresh) {
        const usrData = {...refresh, email: user?.email} as User
        setRefresh(false)
        setUser(usrData)
        setLoggedInChecking(false)
        setUserInStorage(usrData)
      } else {
        setUser(undefined)
        removeUserInStorage()
      }
    }
    refreshTkn()
  }, [setUser, refreshNow, user, setRefresh, setLoggedInChecking, router]);

  return user
}
